import * as React from 'react';

import { ModalModel, ModalContext } from '@notino/react-styleguide';

import {
  ReviewSourceTypes,
  IRating,
} from '@containers/ProductDetailContainer/model';

import { shouldOpenReviewModal } from '../../utils/shouldOpenReviewModal';

import { ReviewsForm } from './ReviewsFormModalBody/loadable';
import { ReviewsSentSuccessModalBody } from './ReviewsSentSuccesModal';

interface IUseReviewModalParameters {
  ratings: IRating[];
  productCode: string;
  masterId: string;
}

const MODAL_OPTIONS = {
  size: ModalModel.Sizes.default,
  type: ModalModel.Types.default,
  header: null,
  center: false,
  noBorders: true,
  withFocusTrap: true,
};
export const useReviewModal = ({
  ratings,
  productCode,
  masterId,
}: IUseReviewModalParameters) => {
  const { toggleModal } = ModalContext.useModalContext();
  const [success, markAsSuccess] = React.useReducer(() => true, false);

  React.useEffect(() => {
    const reviewSource = shouldOpenReviewModal();
    if (reviewSource) {
      toggleModal(
        <div tabIndex={0}>
          <ReviewsForm
            masterId={masterId}
            ratings={ratings}
            source={reviewSource}
            productCode={productCode}
            onSuccess={markAsSuccess}
          />
        </div>,
        MODAL_OPTIONS
      );
    }
  }, [masterId, productCode, ratings, toggleModal]);

  return React.useCallback(() => {
    toggleModal(
      <div tabIndex={0}>
        {success ? (
          <ReviewsSentSuccessModalBody />
        ) : (
          <ReviewsForm
            masterId={masterId}
            ratings={ratings}
            source={ReviewSourceTypes.DIRECT}
            productCode={productCode}
            onSuccess={markAsSuccess}
          />
        )}
      </div>,
      MODAL_OPTIONS
    );
  }, [masterId, productCode, ratings, toggleModal, success]);
};
